import React, { useState, useEffect } from "react";
import secureLocalStorage from "react-secure-storage"; // For secure token storage
import "./SearchVendors.css"; // Add CSS for styling
import { ShowAllCategories } from "../../../context/Slice/VendorManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SearchVendorPage = () => {
  const [vendors, setVendors] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [budgetOptions, setBudgetOptions] = useState([]);
  const dispatch = useDispatch();
  const categories =
    useSelector((state) => state.VendorManagementR.AllCat) || [];
  const token = secureLocalStorage.getItem("token");
  const [eventDetails, setEventDetails] = useState([]);

  useEffect(() => {
    dispatch(ShowAllCategories());
  }, [dispatch]);

  useEffect(() => {
    // Assuming the event ID or other unique identifier is available to fetch the event data
    const fetchEventData = async () => {
      const accessToken = localStorage.getItem("token");
      if (!accessToken) {
        alert("Access token is missing. Please log in again.");
        navigate("/login"); // Redirect to login page
        return;
      }

      try {
        // Fetch event data from the backend
        const response = await axios.get(
          `${BASE_URL}/api/v1/user/budget-tool`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        // Assuming the response contains the event data
        const eventData = response.data;

        // Set event details (this assumes that the backend sends the event categories with prices)
        setEventDetails(eventData.budgetCategories || []);
      } catch (error) {
        console.error("Error fetching event data:", error);
        alert("Failed to fetch event data. Please try again.");
      }
    };

    fetchEventData();
  }, []);

  console.log(eventDetails);

  const parseImageUrl = (imageData) => {
    try {
      const parsedData = JSON.parse(imageData); // Parse the stringified JSON
      const imagePath = parsedData[0]?.path.replace(/\\/g, "/"); // Ensure the path is properly formatted

      // You need to ensure the path is accessible from the frontend
      const imageUrl = `${BASE_URL}/BannerUploads/${imagePath
        .split("/")
        .pop()}`; // Assuming the server serves images from '/BannerUploads'

      return imageUrl || "assets/dummyProfile.jpg"; // Fallback to a default image
    } catch (err) {
      console.warn("Failed to parse image data. Returning default image.", err);
      return "assets/dummyProfile.jpg"; // Fallback to a default image
    }
  };
  const handleViewDetails = (vendor) => {
    // Get the token from local storage
    const token = localStorage.getItem("token");

    if (token) {
      try {
        // Decode the JWT token
        const decodedToken = jwtDecode(token);

        // Extract the role from the decoded token
        const role = decodedToken.role;

        // Save the role to localStorage
        localStorage.setItem("role", role);
        console.log("Role extracted from token:", role);

        if (vendor.ServiceCategory_ID) {
          localStorage.setItem("ServiceCategory_ID", vendor.ServiceCategory_ID);
          console.log("Stored ServiceCategory_ID:", vendor.ServiceCategory_ID);
        }

        // Check if the role is valid
        const allowedRoles = ["USER", "ADMIN", "VENDOR", "CO-ORDINATOR"];
        if (allowedRoles.includes(role)) {
          navigate(`/vendor-details/${vendor.Vendor_ID}`);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  };

  const handleSearch = (query) => {
    setSearchQuery(query);

    const lowercasedQuery = query.toLowerCase();

    const filtered = vendors.filter((vendor) => {
      const matchesSearch =
        vendor.City?.toLowerCase().includes(lowercasedQuery) ||
        vendor.ServiceName?.toLowerCase().includes(lowercasedQuery) ||
        vendor.TotalBudget?.toString()
          .toLowerCase()
          .includes(lowercasedQuery) ||
        vendor.Address?.toLowerCase().includes(lowercasedQuery) ||
        vendor.SpecialBadge?.toLowerCase().includes(lowercasedQuery) ||
        vendor.CompanyName?.toLowerCase().includes(lowercasedQuery) ||
        vendor.BudgetSlab?.toLowerCase().includes(lowercasedQuery);

      return matchesSearch;
    });

    setFilteredVendors(filtered);
  };

  useEffect(() => {
    if (!token) {
      setError("Token not found. Please log in.");
      setLoading(false);
      return;
    }

    const fetchVendors = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${BASE_URL}/api/v1/User/searchVendor`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();

        console.log(data.data);

        const updatedData = data.data.map((item) => {
          if (
            item.ServiceName === "VENUE" ||
            item.ServiceName === "WEDDING CATERERS"
          ) {
            const dynamicData = JSON.parse(item.DynamicData);

            return {
              ...item,
              BudgetSlab: dynamicData.BudgetSlab || null,
              DynamicData: dynamicData,
            };
          } else {
            return item;
          }
        });

        console.log(updatedData);

        setVendors(updatedData);
        setFilteredVendors(updatedData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchVendors();
  }, []);

  console.log(filteredVendors);

  const handleCategoryChange = (categoryName) => {
    setSelectedCategory(categoryName);

    // Find the selected category object
    const selectedCategoryData = parsedCategories.find(
      (category) => category.CategorieName === categoryName
    );

    if (selectedCategoryData) {
      // Determine which budget field to use
      const budgetField = selectedCategoryData.CategorieFields.find((field) =>
        ["VENUE", "Wedding Caterers"].includes(categoryName)
          ? field.fieldName.trim() === "BudgetSlab"
          : field.fieldName.trim() === "TotalBudget"
      );

      setBudgetOptions(budgetField ? budgetField.options : []);
    } else {
      setBudgetOptions([]); // Reset if no category is selected
    }
  };

  const ServiceNameArr = vendors
    ? [...new Set(vendors.map((data) => data.ServiceName))]
    : [];

  const parsedServiceNameArr = new Set(ServiceNameArr);

  // Filtering categories based on ServiceNameArr
  const filteredCategories = categories.filter((category) =>
    parsedServiceNameArr.has(category.CategorieName)
  );

  const parsedCategories = filteredCategories.map((category) => ({
    ...category,
    CategorieFields: JSON.parse(category.CategorieFields),
  }));

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div id="SearchVendor" className="vendor-container">
      <h1>Vendor List</h1>

      {/* Search Bar */}
      <div className="search-bar">
        {/* Category Dropdown */}
        <select
          id="category"
          value={selectedCategory}
          onChange={(e) => {
            handleCategoryChange(e.target.value);
            handleSearch(e.target.value);
          }}
        >
          <option value="">Select Category</option>
          {parsedCategories.map((category, index) => (
            <option key={index} value={category.CategorieName}>
              {category.CategorieName}
            </option>
          ))}
        </select>

        {/* Budget Dropdown (Updates based on Category) */}
        {/* <select
          id="budget"
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
        >
          <option value="">Select Budget</option>
          {budgetOptions.map((option, index) => (
            <option key={index} value={option.trim()}>
              {option.trim()}
            </option>
          ))}
        </select> */}

        <input
          type="text"
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
          placeholder="Search vendors by city, service, budget, address, etc."
        />
      </div>

      {/* Vendor Cards Container */}
      <div className="vendor-sections">
  {Object.entries(
    filteredVendors
      .filter((vendor) => vendor.status === "approved") // ✅ Only approved vendors
      .filter((vendor) => {
        const eventService = eventDetails.find(
          (event) =>
            event.type.trim().toUpperCase() ===
            vendor.ServiceName.trim().toUpperCase()
        );

        if (!eventService) return false; // Skip vendors not in eventDetails

        // Directly compare `BudgetSlab` or `TotalBudget` with `price`
        const isMatchingBudget = ["VENUE", "WEDDING CATERERS"].includes(
          vendor.ServiceName.toUpperCase()
        )
          ? vendor.BudgetSlab?.trim() === eventService.price.trim()
          : vendor.TotalBudget?.trim() === eventService.price.trim();

        return isMatchingBudget;
      })
      .reduce((acc, vendor) => {
        if (!acc[vendor.ServiceName]) acc[vendor.ServiceName] = [];
        acc[vendor.ServiceName].push(vendor);
        return acc;
      }, {})
  ).map(([serviceName, vendors]) => (
    <div key={serviceName} className="vendor-section">
      <h2 className="service-title">{serviceName || "Other Services"}</h2>
      
      {vendors.length > 0 ? ( // ✅ Check if vendors exist for this category
        <div className="vendor-cards">
          {vendors.map((vendor) => {
            const bannerImage = JSON.parse(vendor.BannerImage || "[]")[0]?.path;
            const serviceLocations = JSON.parse(
              vendor.serviceLocations || "[]"
            );
            const address = serviceLocations[0]?.officeName || vendor.Address;

            return (
              <div className="vendor-card" key={vendor.id}>
                {bannerImage && (
                  <img
                    src={
                      vendor.BannerImage
                        ? parseImageUrl(vendor.BannerImage)
                        : "assets/dummyProfile.jpg"
                    }
                    className="card-img-top"
                    alt={vendor.ServiceName}
                  />
                )}
                <div className="vendor-details">
                  <h2 className="vendor-name">
                    {vendor.CompanyName || "N/A"}
                  </h2>
                  <p className="vendor-city">
                    <strong>City:</strong> {vendor.City || "N/A"}
                  </p>
                  <p className="vendor-service-name">
                    <strong>Service:</strong> {vendor.ServiceName || "N/A"}
                  </p>
                  <p className="vendor-budget">
                    <strong>Budget:</strong>{" "}
                    {vendor.ServiceName.toUpperCase() === "VENUE"
                      ? vendor.BudgetSlab || "N/A"
                      : vendor.TotalBudget || "N/A"}
                  </p>
                </div>
                <button
                  className="btn btn-primary premium-vendor-btn"
                  onClick={() => handleViewDetails(vendor)}
                >
                  View
                </button>
              </div>
            );
          })}
        </div>
      ) : (
        // ✅ Message when no vendors are available for the category
        <p className="no-vendors-message">
          No vendors available for {serviceName}.
        </p>
      )}
    </div>
  ))}
</div>

    </div>
  );
};

export default SearchVendorPage;
